/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9 17L6 14M9 17L12 14M9 17L9 12.4C9 10.1598 9 9.03969 9.43597 8.18404C9.81947 7.43139 10.4314 6.81947 11.184 6.43597C12.0397 6 13.1598 6 15.4 6H17.0001"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M9 17L6 14M9 17L12 14M9 17V13.5C9 11.1703 9 10.0054 9.3806 9.08658C9.88807 7.86144 10.8614 6.88807 12.0866 6.3806C13.0054 6 14.1703 6 16.5 6V6H17.0001M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM15.3999 5.25H15.3669H15.3669C14.2748 5.24999 13.4093 5.24999 12.7117 5.30699C11.9983 5.36527 11.3947 5.48688 10.8435 5.76772C9.94971 6.22312 9.22306 6.94978 8.76766 7.84354C8.48682 8.39472 8.36521 8.99834 8.30693 9.71173C8.24993 10.4094 8.24993 11.2748 8.24994 12.367V12.367V12.4V15.1893L6.53027 13.4697C6.23738 13.1768 5.7625 13.1768 5.46961 13.4697C5.17672 13.7626 5.17672 14.2374 5.46961 14.5303L8.46961 17.5303C8.7625 17.8232 9.23738 17.8232 9.53027 17.5303L12.5303 14.5303C12.8232 14.2374 12.8232 13.7626 12.5303 13.4697C12.2374 13.1768 11.7625 13.1768 11.4696 13.4697L9.74994 15.1893V12.4C9.74994 11.2675 9.75052 10.4633 9.80195 9.83388C9.85265 9.21325 9.94903 8.829 10.1042 8.52453C10.4158 7.913 10.9129 7.41582 11.5245 7.10423C11.8289 6.94909 12.2132 6.85271 12.8338 6.80201C13.4632 6.75058 14.2675 6.75 15.3999 6.75H17C17.4142 6.75 17.75 6.41421 17.75 6C17.75 5.58579 17.4142 5.25 17 5.25H15.3999Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M9 17L6 14M9 17L12 14M9 17V13.5C9 11.1703 9 10.0054 9.3806 9.08658C9.88807 7.86144 10.8614 6.88807 12.0866 6.3806C13.0054 6 14.1703 6 16.5 6V6H17.0001"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M9 17L6 14M9 17L12 14M9 17V13.5C9 11.1703 9 10.0054 9.3806 9.08658C9.88807 7.86144 10.8614 6.88807 12.0866 6.3806C13.0054 6 14.1703 6 16.5 6V6H17.0001M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.367 5.25L15.4 5.25H17.0001C17.4143 5.25 17.7501 5.58579 17.7501 6C17.7501 6.41421 17.4143 6.75 17.0001 6.75H15.4C14.2675 6.75 13.4633 6.75058 12.8339 6.80201C12.2133 6.85271 11.829 6.94909 11.5245 7.10423C10.913 7.41582 10.4158 7.913 10.1042 8.52453C9.94909 8.829 9.85271 9.21325 9.80201 9.83388C9.75058 10.4633 9.75 11.2675 9.75 12.4V15.1893L11.4697 13.4697C11.7626 13.1768 12.2374 13.1768 12.5303 13.4697C12.8232 13.7626 12.8232 14.2374 12.5303 14.5303L9.53033 17.5303C9.23744 17.8232 8.76256 17.8232 8.46967 17.5303L5.46967 14.5303C5.17678 14.2374 5.17678 13.7626 5.46967 13.4697C5.76256 13.1768 6.23744 13.1768 6.53033 13.4697L8.25 15.1893L8.25 12.4V12.367C8.25 11.2749 8.24999 10.4094 8.30699 9.71173C8.36527 8.99835 8.48688 8.39472 8.76772 7.84355C9.22312 6.94978 9.94978 6.22312 10.8435 5.76772C11.3947 5.48688 11.9983 5.36527 12.7117 5.30699C13.4094 5.24999 14.2749 5.24999 15.367 5.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
